import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import { BookingService } from 'src/app/services/booking/booking.service';
import { PlatformService } from 'src/app/services/platform/platform.service';
import { RegisterResetpassService } from 'src/app/services/register-resetpass/register-resetpass.service';
import { SubSink } from 'subsink';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';

const place = null as google.maps.places.PlaceResult;
type Components = typeof place.address_components;

@Component({
  selector: 'app-booking-info',
  templateUrl: './booking-info.page.html',
  styleUrls: ['./booking-info.page.scss'],
})
export class BookingInfoPage implements OnInit {
  moment: any = moment;

  isMobileDevice: boolean;
  bookingForm: FormGroup;
  subscription = new SubSink();
  isCreate: boolean = true;
  showSpinner: boolean = false;
  response_message: string = '';
  hasResponseError: boolean = false;

  showBookingsLoader: boolean = false;

  isAddBookingOpen: boolean = false;
  roles: any;
  booking: any = null;
  myBookings: any = [];

  date_today = null;
  date_pipe = new DatePipe('en-us');

  @ViewChild('search')
  public searchElementRef: ElementRef;
  public place: google.maps.places.PlaceResult;

  constructor(
    private fb: FormBuilder,
    private platform: PlatformService,
    private modalCtrl: ModalController,
    private toast: ToastController,
    private ngZone: NgZone,
    private registerService: RegisterResetpassService,
    private bookingService: BookingService,
    private alertCtrl: AlertController,
  ) {
    this.isMobileDevice = this.platform.isMobile();
  }

  ngOnInit() {
    this.date_today = this.date_pipe.transform(Date.now(),'yyyy-MM-dd');
    this.showBookingLoader();
    this.readyBookingForm();
    this.getUserAccountTypes();
    this.getMyBookingsInfo();
  }

  ngAfterViewInit() {
    this.initializeAutocomplete();
  }

  readyBookingForm() {
    this.bookingForm = this.fb.group({
      booking_email: ['', [Validators.required, Validators.pattern('^[^@]+@([-\\w]+\\.)+[A-Za-z]{2,4}$')]],
      booking_phone: ['', [Validators.required, Validators.pattern('^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$')]],
      average_booking_pay_out: ['', [Validators.required, Validators.pattern(/\S+/)]],
      category: [null, Validators.required],
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
      price_range_from: [null, [Validators.required, (control: AbstractControl) => Validators.max(this.bookingForm?.value.price_range_to)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]],
      price_range_to: [null, [Validators.required, (control: AbstractControl) => Validators.min(this.bookingForm?.value.price_range_from)(control), Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]],
      distance: ['', [Validators.required, Validators.pattern("^(?!-)[1-9][0-9]*(\.[0-9]+)?$|^0\.[0-9]*[1-9]+[0-9]*$")]],
      price_negotiable: ['', Validators.required],
      booking_address: ['', [Validators.required, Validators.pattern(/\S+/)]],
      lat: [null, Validators.required],
      long: [null, Validators.required],
    });
  }

  initializeAutocomplete() {
    const input = document.getElementById("booking_address") as HTMLInputElement;
    const options = {
      fields: ["formatted_address", "geometry", "name"],
      strictBounds: false,
      types: ["establishment"],
    };
    const autocomplete = new google.maps.places.Autocomplete(input, options);
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        this.onPlaceChange(autocomplete.getPlace());
      });
      const place = autocomplete.getPlace();
      let complete_address = place.name + ", " + place.formatted_address;
      // console.log("address --> ", complete_address);
      this.bookingForm.get('booking_address').setValue(complete_address);
    });
  }

  onPlaceChange(place: google.maps.places.PlaceResult) {
    var latitude = place.geometry.location.lat();
    var longitude = place.geometry.location.lng();
    this.bookingForm.get('lat').setValue(latitude);
    this.bookingForm.get('long').setValue(longitude);
    // console.log("latitude --> ", latitude, "longitude --> ",longitude);
  }

  getUserAccountTypes() {
    this.subscription.sink = this.registerService.getAccountTypes().subscribe(
      (roles: any[]) => {
        this.roles = roles['data'];
      },
      (error) => console.log(error)
    );
  }

  emptyLatLong(ev){
    if (ev.which == 8 || ev.which == 46 || ev.which == 17) {          //empty on pressing backspace/delete/ctrl
      this.bookingForm.get('lat').setValue(null);
      this.bookingForm.get('long').setValue(null);
    }
  }

  contextFunc() {
    return false;    //to disable right click context menu
  }

  getMyBookingsInfo() {
    this.subscription.sink = this.bookingService
      .getMyBookings()
      .subscribe(
        (res_myBookings: any) => {
          // this.readyFormData(res_myBookings);
          this.myBookings = res_myBookings.data;
          this.showBookingsLoader = false;
          console.log("my bookings data ---> ",this.myBookings);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  //GETTERS

  get booking_email() {
    return this.bookingForm.get('booking_email');
  }

  get booking_phone() {
    return this.bookingForm.get('booking_phone');
  }

  get average_booking_pay_out() {
    return this.bookingForm.get('average_booking_pay_out');
  }

  get category() {
    return this.bookingForm.get('category');
  }

  get booking_start_date() {
    return this.bookingForm.get('start_date');
  }

  get booking_end_date() {
    return this.bookingForm.get('end_date');
  }

  get price_range_from() {
    return this.bookingForm.get('price_range_from');
  }

  get price_range_to() {
    return this.bookingForm.get('price_range_to');
  }

  get distance() {
    return this.bookingForm.get('distance');
  }

  get price_negotiable() {
    return this.bookingForm.get('price_negotiable');
  }
  get booking_address() {
    return this.bookingForm.get('booking_address');
  }

  get lat() {
    return this.bookingForm.get('lat');
  }
  get long() {
    return this.bookingForm.get('long');
  }
  //#GETTERS

  updateBooking(id) {
    this.showSpinner = true;
    // console.log("update booking id --> ",id);
    let bookingInfo = this.bookingForm.value;
    bookingInfo['id'] = id;
    // console.log('update form data ---------->', bookingInfo);
    this.subscription.sink = this.bookingService
        .updateBooking(bookingInfo)
        .subscribe(
          (res: any) => {
            this.showSpinner = false;
            // console.log('update booking response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);

            this.bookingForm.reset();
            this.isAddBookingOpen = false;
            this.getMyBookingsInfo();
          },
          (err: any) => {
            this.showSpinner = false;
            console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred updating your Booking, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }


  submitBooking() {
    this.showSpinner = true;
    let bookingInfo = this.bookingForm.value;
    console.log('form data ---------->', bookingInfo);
    this.subscription.sink = this.bookingService
      .createBooking(bookingInfo)
      .subscribe(
        (res: any) => {
          this.isCreate = false;
          this.showSpinner = false;
          // console.log('create booking response ----------> ', res);
          this.hasResponseError = false;
          this.response_message = res.message;
          this.presentSuccessToast(this.response_message);
          this.bookingForm.reset();
          this.isAddBookingOpen = false;
          this.getMyBookingsInfo();
        },
        (err: any) => {
          this.showSpinner = false;
          console.log('Error -------> ', err);
          this.hasResponseError = true;
          this.response_message = "An error occurred adding your Booking, please try again later.";
          this.presentErrorToast(this.response_message);
        }
      );
  }

  async presentSuccessToast(res_message) {
    const toast = await this.toast.create({
      header: 'Success',
      color: 'success',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  async presentErrorToast(res_message) {
    const toast = await this.toast.create({
      header: 'Failed',
      color: 'danger',
      message: res_message,
      position: 'top',
      duration: 3000,
    });
    await toast.present();
  }

  getBooking(id) {
    this.subscription.sink = this.bookingService
      .getBookingDetails(id)
      .subscribe(
        (res: any) => {
          this.booking = res.data;
          // console.log("booking ==> ",this.booking);
          this.readyEditFormData(this.booking);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  goToEditForm(id) {
    // console.log("booking id --> ", id);
    this.getBooking(id);
  }

  readyEditFormData(booking) {
    this.bookingForm.patchValue({
      booking_email: booking.booking_email,
      booking_phone: booking.booking_phone ?? '',
      average_booking_pay_out: booking.average_booking_pay_out ?? '',
      category: booking.category,
      start_date: booking.start_date ?? null,
      end_date: booking.end_date ?? null,
      price_range_from: booking.price_range_from,
      price_range_to: booking.price_range_to,
      distance: booking.distance,
      price_negotiable: booking.price_negotiable,
      booking_address: booking.booking_address ?? null,
      lat: booking.lat ?? null,
      long: booking.long ?? null,
    });
    this.isAddBookingOpen = true;
  }


  deleteBooking(id) {
    // console.log("delete booking id --> ",id);
    this.subscription.sink = this.bookingService
        .deleteBooking(id)
        .subscribe(
          (res: any) => {
            // console.log('delete booking response ----------> ', res);
            this.hasResponseError = false;
            this.response_message = res.message;
            this.presentSuccessToast(this.response_message);
            this.getMyBookingsInfo();
          },
          (err: any) => {
            console.log('Error -------> ', err);
            this.hasResponseError = true;
            this.response_message = "An error occurred deleting your Booking, please try again later.";
            this.presentErrorToast(this.response_message);
          }
        );
  }

  showBookingLoader() {
    this.showBookingsLoader = true;
  }

  openAddBooking() {
    this.isAddBookingOpen = true;
    this.booking = null;
    this.bookingForm.reset();
  }

  goBackToBookingsList() {
    this.isAddBookingOpen = false;
    this.booking = null;
    this.bookingForm.reset();
  }

  closeModal() {
    return this.modalCtrl.dismiss();
  }

  async deleteConfirm(booking_id) {
    let alert = this.alertCtrl.create({
      message: 'Are you sure, you want to delete this booking?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            // console.log('Cancel clicked');
          }
        },
        {
          text: 'Confirm',
          handler: () => {
            this.deleteBooking(booking_id);
          }
        }
      ]
    });
    (await alert).present();
  }

}
